import React, { useContext, useRef } from 'react';

import { Typography, IconButton, Stack, Paper, Container } from '@mui/material';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';

import { DataContext } from '../../../../context/DataContext';
import { conv2Letras } from '../../../../helpers/n2Letras';
import { PrintReport } from '../../../../components/PrintReport';

const PagoAguinaldoDetails = ({ selected }) => {
	const { title, slogan, icon } = useContext(DataContext);

	const { id, desde, hasta, description, monto, employee } = selected;

	const compRef = useRef();

	const pageStyle = `
    @media print {
      html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
    }
    @media all {
      .pagebreak {
        display: none;
      }
    }
    @media print {
      .pagebreak {
        page-break-before: always;
      }
    }  
    @page { margin: 10mm; }
  `;

	return (
		<div>
			<Paper
				style={{
					padding: 20,
					textAlign: 'center'
				}}
			>
				<Stack display="flex" justifyContent="center">
					<img src={icon} style={{ width: 50, height: 50 }} />
					<Stack>
						<Typography variant="h5" textAlign={'center'}>
							{title}
						</Typography>
						<Typography textAlign={'center'}>{slogan}</Typography>
					</Stack>
					<ReactToPrint
						trigger={() => {
							return (
								<IconButton
									variant="outlined"
									style={{ position: 'absolute', right: 50, top: 75 }}
								>
									<PrintRoundedIcon
										style={{ fontSize: 35, color: '#2979ff', width: 35 }}
									/>
								</IconButton>
							);
						}}
						content={() => compRef.current}
						pageStyle={pageStyle}
					/>
				</Stack>

				<Stack
					direction="row"
					justifyContent="space-between"
					paddingLeft={20}
					// paddingRight={5}
				>
					<Stack />
					<Stack>
						<Typography variant="h4" textAlign={'center'}>
							Recibo
						</Typography>
					</Stack>
					<Stack>
						<Typography variant="h6" color="#f50057" textAlign="right">
							{`N° ${id}`}
						</Typography>
						<Typography variant="h6" color="#f50057" textAlign="right">
							{`Valor: ${new Intl.NumberFormat('es-NI', {
								style: 'currency',
								currency: 'NIO'
							}).format(monto)}`}
						</Typography>
					</Stack>
				</Stack>

				<Stack spacing={3} marginTop={2}>
					<Typography textAlign={'left'}>
						EN CONCEPTO DE:
						<Typography
							sx={{
								marginLeft: 1,
								textDecoration: 'underline',
								textUnderlineOffset: 8
							}}
							display="inline"
						>
							{` ${description}, DESDE: ${moment(desde).format('L')}, HASTA: ${moment(
								hasta
							).format('L')}`}
						</Typography>
					</Typography>

					<Typography textAlign={'left'}>
						LA CANTIDAD DE:
						<Typography
							sx={{
								marginLeft: 1,
								textDecoration: 'underline',
								textUnderlineOffset: 8
							}}
							display="inline"
						>
							{` ${conv2Letras(monto)}`}
						</Typography>
					</Typography>

					<Typography textAlign={'right'}>
						{`Fecha: ${moment().format('dddd,')} ${moment().format(
							'D'
						)} de ${moment().format('MMMM')} de ${moment().format('YYYY')}`}
					</Typography>
				</Stack>

				<Stack direction="row" justifyContent="space-between" marginTop={10}>
					<Stack>
						<Typography textAlign={'center'}>
							--------------------------------------------
						</Typography>
						<Typography textAlign={'center'}>ENTREGUE CONFORME</Typography>
						<Typography textAlign={'center'}>NELSON UBALDO RAMOS MAYORGAO</Typography>
					</Stack>
					<Stack>
						<Typography textAlign={'center'}>
							--------------------------------------------
						</Typography>
						<Typography textAlign={'center'}>RECIBI CONFORME</Typography>
						<Typography textAlign={'center'}>{employee}</Typography>
					</Stack>
				</Stack>
			</Paper>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport ref={compRef} titulo={'Comprobante de Pago de Aguinaldo'}>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />

						<Stack
							direction="row"
							justifyContent="space-between"
							paddingLeft={20}
							// paddingRight={5}
						>
							<Stack />
							<Stack>
								<Typography variant="h5" textAlign={'center'}>
									Recibo
								</Typography>
							</Stack>
							<Stack>
								<Typography color="#f50057" textAlign="right">
									{`N° ${id}`}
								</Typography>
								<Typography color="#f50057" textAlign="right">
									{`Valor: ${new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(monto)}`}
								</Typography>
							</Stack>
						</Stack>

						<Stack spacing={2} marginTop={1}>
							<Typography textAlign={'left'} fontSize={12}>
								EN CONCEPTO DE:
								<Typography
									sx={{
										marginLeft: 1,
										marginTop: 5,
										textDecoration: 'underline',
										textUnderlineOffset: 8,
										lineHeight: 2
									}}
									fontSize={12}
									display="inline"
								>
									{` ${description}, DESDE: ${moment(desde).format(
										'L'
									)}, HASTA: ${moment(hasta).format('L')}`}
								</Typography>
							</Typography>

							<Typography textAlign={'left'} fontSize={12}>
								LA CANTIDAD DE:
								<Typography
									sx={{
										marginLeft: 1,
										textDecoration: 'underline',
										textUnderlineOffset: 8
									}}
									display="inline"
									fontSize={12}
								>
									{` ${conv2Letras(monto)}`}
								</Typography>
							</Typography>

							<Typography textAlign={'right'} fontSize={12}>
								{`Fecha: ${moment().format('dddd,')} ${moment().format(
									'D'
								)} de ${moment().format('MMMM')} de ${moment().format('YYYY')}`}
							</Typography>
						</Stack>

						<Stack direction="row" justifyContent="space-between" marginTop={5}>
							<Stack>
								<Typography textAlign={'center'}>
									--------------------------------------------
								</Typography>
								<Typography textAlign={'center'} fontSize={12}>
									ENTREGUE CONFORME
								</Typography>
								<Typography textAlign={'center'} fontSize={12}>
									NELSON UBALDO RAMOS MAYORGA
								</Typography>
							</Stack>
							<Stack>
								<Typography textAlign={'center'}>
									--------------------------------------------
								</Typography>
								<Typography textAlign={'center'} fontSize={12}>
									RECIBI CONFORME
								</Typography>
								<Typography textAlign={'center'} fontSize={12}>
									{employee}
								</Typography>
							</Stack>
						</Stack>
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default PagoAguinaldoDetails;
